import { PaymentTypes } from './payment-types';

export type PaymentRequisite =
    | {
          paymentType?: PaymentTypes.BANK_TRANSFER_BSB;
          bsb: number;
          accountNumber: number;
          accountName: string;
          firstName: string;
          secondName: string;
          email: string;
      }
    | {
          paymentType?: PaymentTypes.PAY_ID_EMAIL;
          email: string;
          firstName: string;
          secondName: string;
      }
    | {
          paymentType?: PaymentTypes.PAY_ID_MOBILE;
          mobileNumber: string;
          firstName: string;
          secondName: string;
      };

export interface RequisiteSchema {
    [key: string]: RequisiteSchemaEntry;
}

export interface RequisiteSchemaEntry {
    type: string;
    validation: RequisiteSchemaValidations[];
}

export enum RequisiteSchemaValidations {
    EMAIL = 'email',
    REQUIRED = 'required'
}
